import React, { useEffect, useState } from "react";
import { 
   ArrowLeftOutlined, 
   DeleteFilled, 
   EditFilled, 
   PlusOutlined 
} from "@ant-design/icons";
import { Button, Col, Row, Spin } from "antd";
import { t } from "i18next";
import * as _ from "lodash";
import { useParams, useNavigate } from "react-router-dom";
import { getPerformanceModuleById, deletePerformanceModuleById } from "services/performance_module";
import { Util } from "common/util";
import "./index.css";


export default function PerformanceModuleList() {
   const [datas, setDatas] = useState([])
   const [loading, setLoading] = useState(false);
   const { id } = useParams();
   const navigate = useNavigate();

   const fetchData = () => {
      setLoading(true)
      getPerformanceModuleById(id).then((response) => {
         if (response?.data) {
            setDatas(response.data.level1s);
         }
      }).finally(() => setLoading(false));
   }

   useEffect(() => {
      fetchData()
      // eslint-disable-next-line
   }, []);

   const onBack = () => {
      navigate("/performance/performance-module")
   }

   const onUpdate = (childId) => {
      if (Util.getInstance().hasPermission("edit", "performance module")) {
         navigate(`/performance/performance-module/create-update/${id}/${childId}`);
      } else {
         Util.getInstance().sweetAlertMessage(t("text_no_permission"), "warning");
      }
   }

   const onAddNew = () => {
      navigate(`/performance/performance-module/create-update/${id}/null`)
   }

   const onDelete = (childId) => {
      if (Util.getInstance().hasPermission("delete", "performance module")) {
         Util.getInstance()
         .sweetAlertConfirm(t("text_confrim"), "You won't be able to revert this!", ["Cancel", "Yes, delete it!"])
         .then((willDelete) => {
            if (willDelete) {
               deletePerformanceModuleById(childId).then(() => {
                  fetchData()
               })
            }
         });
      } else {
         Util.getInstance().sweetAlertMessage(t("text_no_permission"), "warning");
      }
   }

   return (
      <>
         <Row className="btn-navigation">
            <Col span={12}>
               <div className="pull-left">
                  <Button onClick={onBack}>
                     <ArrowLeftOutlined />
                     {t("text_back")}
                  </Button>
                  <span className="title">
                     Performance Module List
                  </span>
               </div>
            </Col>
            <Col span={12}>
               <div className="pull-right">
                  <Button icon={<PlusOutlined />} onClick={onAddNew}>{t("text_add_new")}</Button>
               </div>
            </Col>
         </Row>
         <Row style={{ height: "84vh", overflowY: "auto" }}>
            {
               loading ? <Spin spinning={loading} style={{ display: "flex", height: "84vh", justifyContent: 'center', width: "100%", alignItems: "center" }} /> :
                  <Col span={24}>
                     <div id="performance-module" style={{ padding: "0 15px" }}>
                        {
                           datas.map((level1) => {
                              return <React.Fragment key={level1.id}>
                                 <div className="ant-list ant-list-split ant-list-bordered ant-list-something-after-last-item css-dev-only-do-not-override-mxhywb" style={{ margin: "15px 0px" }}>
                                    <div className="ant-list-header" >
                                       <Row>
                                          <Col span={22} style={{
                                             display: "flex",
                                             alignItems: "center",

                                          }}>
                                             <div dangerouslySetInnerHTML={{ __html: level1.title }} />
                                          </Col>
                                          <Col span={1} style={{
                                             display: "flex",
                                             alignItems: "center",
                                             justifyContent: "center"
                                          }}>
                                             <Button
                                                danger
                                                title={t("text_delete")}
                                                icon={<DeleteFilled style={{ color: "#fff" }} />}
                                                shape="circle"
                                                type="primary"
                                                style={{
                                                   marginTop: 0,
                                                   height: 35,
                                                   width: 35,
                                                   borderRadius: 35,
                                                   border: "none"
                                                }}
                                                onClick={() => onDelete(level1.id)}
                                             />
                                          </Col>
                                          <Col span={1} style={{
                                             display: "flex",
                                             alignItems: "center",
                                             justifyContent: "center"
                                          }}>
                                             <Button
                                                style={{
                                                   marginTop: 0,
                                                   height: 35,
                                                   width: 35,
                                                   borderRadius: 35,
                                                   border: "none",

                                                }}
                                                type="primary"
                                                title={`${t("text_update")}`}
                                                onClick={() => onUpdate(level1.id)}
                                                icon={<EditFilled style={{ color: "#fff" }} />}
                                             />
                                          </Col>
                                       </Row>
                                    </div>
                                 </div>
                                 {
                                    _.sortBy(level1.level2s, "order").map(level2 => (
                                       <React.Fragment key={level2.id}>
                                          <div className="ant-list ant-list-split ant-list-bordered ant-list-something-after-last-item css-dev-only-do-not-override-mxhywb" style={{ margin: "15px 0 15px 24px" }}>
                                             <div className="ant-list-header" >
                                                <Row>
                                                   <Col span={22} style={{
                                                      display: "flex",
                                                      alignItems: "center",

                                                   }}>
                                                      <div dangerouslySetInnerHTML={{ __html: level2.title }} />
                                                   </Col>
                                                   <Col span={1} style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center"
                                                   }}>
                                                      <Button
                                                         danger
                                                         title={t("text_delete")}
                                                         icon={<DeleteFilled style={{ color: "#fff" }} />}
                                                         shape="circle"
                                                         type="primary"
                                                         style={{
                                                            marginTop: 0,
                                                            height: 35,
                                                            width: 35,
                                                            borderRadius: 35,
                                                            border: "none"
                                                         }}
                                                         onClick={() => onDelete(level2.id)}
                                                      />
                                                   </Col>
                                                   <Col span={1} style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center"
                                                   }}>
                                                      <Button
                                                         style={{
                                                            marginTop: 0,
                                                            height: 35,
                                                            width: 35,
                                                            borderRadius: 35,
                                                            border: "none",

                                                         }}
                                                         type="primary"
                                                         title={`${t("text_update")}`}
                                                         onClick={() => onUpdate(level2.id)}
                                                         icon={<EditFilled style={{ color: "#fff" }} />}
                                                      />
                                                   </Col>
                                                </Row>
                                             </div>
                                          </div>
                                          {
                                             level2.level3s.map(level3 => (
                                                <div key={level3.id} className="ant-list ant-list-split ant-list-bordered ant-list-something-after-last-item css-dev-only-do-not-override-mxhywb" style={{ margin: "15px 0 15px 60px" }}>
                                                   <div className="ant-list-header" >
                                                      <Row>
                                                         <Col span={22} style={{
                                                            display: "flex",
                                                            alignItems: "center",

                                                         }}>
                                                            <div dangerouslySetInnerHTML={{ __html: level3.title }} />
                                                         </Col>
                                                         <Col span={1} style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                         }}>
                                                            <Button
                                                               danger
                                                               title={t("text_delete")}
                                                               icon={<DeleteFilled style={{ color: "#fff" }} />}
                                                               shape="circle"
                                                               type="primary"
                                                               style={{
                                                                  marginTop: 0,
                                                                  height: 35,
                                                                  width: 35,
                                                                  borderRadius: 35,
                                                                  border: "none"
                                                               }}
                                                               onClick={() => onDelete(level3.id)}
                                                            />
                                                         </Col>
                                                         <Col span={1} style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                         }}>
                                                            <Button
                                                               style={{
                                                                  marginTop: 0,
                                                                  height: 35,
                                                                  width: 35,
                                                                  borderRadius: 35,
                                                                  border: "none",

                                                               }}
                                                               type="primary"
                                                               title={`${t("text_update")}`}
                                                               onClick={() => onUpdate(level3.id)}
                                                               icon={<EditFilled style={{ color: "#fff" }} />}
                                                            />
                                                         </Col>
                                                      </Row>
                                                   </div>
                                                </div>
                                             ))
                                          }
                                       </React.Fragment>
                                    ))
                                 }
                              </React.Fragment>
                           })
                        }

                     </div>
                  </Col>
            }

         </Row>
      </>
   )
}
